<template>
    <Question :question="question">
      <div class="form-group">
        <label for="social">Social Security Number</label>
        <div class="input-group">
          <input name="social" type="text" class="form-control" pattern="[0-9]{3}" maxlength="3" v-model="firstThree" placeholder="XXX" required>
          <input type="text" class="form-control" pattern="[0-9]{2}" maxlength="2" v-model="middleTwo" placeholder="XX" required>
          <input type="text" class="form-control" pattern="[0-9]{4}" maxlength="4" v-model="lastFour" placeholder="XXXX" required>
        </div>
        <br>
        <div class="input-group">
            <div class="input-group-prepend">
                <span class="input-group-text">VA File Number</span>
            </div>
            <input type="number" class="form-control" v-model="vaFileNumber" required>
        </div>
        <br>
        <p class="text-center">Use SSN if VA File Number is unknown.</p>        
      </div>
    </Question>
</template>

<script>
import Question from '../Question.vue'

export default {
  name: 'SSN',
  props: {
      question: String
  },
  components: {
      Question
  },
  data: function() {
      return {
          "firstThree": "",
          "middleTwo": "",
          "lastFour": "",
          "vaFileNumber": ""
      }
  }
}
</script>